
import { call, put, takeEvery } from 'redux-saga/effects'

import { createActionTypes } from '../../common/client/sagas/common';
import { ERROR_CLEAR_ACTION_TYPE, ERROR_CREATE_ACTION_TYPE } from '../../common/client/sagas/operationStatus';
import server from '../server';

export const GET_DATA_MODEL_DEFINITION_ACTION_TYPE = createActionTypes('data/GET_DATA_MODEL_DEFINITION');

export default function getActions(dispatch) {
    return {
        getDataModelDefinition: (token, projectId, debug) => dispatch({
            type: GET_DATA_MODEL_DEFINITION_ACTION_TYPE.DEFAULT,
            token, projectId, debug
        })
    };
}

function getDataModelDefinition(action) {
    return new Promise((resolve, reject) => {
        server.data.getDataModelDefinition(
            action.token, action.projectId, action.debug,
            (err, definition) => {
                if (definition) {
                    resolve(definition);
                } else {
                    reject(err);
                }
            }
        );
    });
}

function* workGetDataModelDefinition(action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        yield put({type: GET_DATA_MODEL_DEFINITION_ACTION_TYPE.LOADING});
        const dataModelDefinition = yield call(getDataModelDefinition, action);
        yield put({type: GET_DATA_MODEL_DEFINITION_ACTION_TYPE.SUCCESS, dataModelDefinition: dataModelDefinition});
    } catch (error) {
        yield put({type: GET_DATA_MODEL_DEFINITION_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

export function* watchGetDataModelDefinition() {
    yield takeEvery(GET_DATA_MODEL_DEFINITION_ACTION_TYPE.DEFAULT, workGetDataModelDefinition);
}
